export default `/* Ids Layout Flex Component */
/* Ids Layout Flex Item Component */
:host([align-self=auto]),
.ids-layout-flex-item-align-self-auto {
  align-self: auto;
}

:host([align-self=baseline]),
.ids-layout-flex-item-align-self-baseline {
  align-self: baseline;
}

:host([align-self=center]),
.ids-layout-flex-item-align-self-center {
  align-self: center;
}

:host([align-self=stretch]),
.ids-layout-flex-item-align-self-stretch {
  align-self: stretch;
}

:host([align-self=flex-start]),
.ids-layout-flex-item-align-self-flex-start {
  align-self: flex-start;
}

:host([align-self=flex-end]),
.ids-layout-flex-item-align-self-flex-end {
  align-self: flex-end;
}

:host([grow="0"]),
.ids-layout-flex-item-grow-0 {
  flex-grow: 0;
}

:host([grow="1"]),
.ids-layout-flex-item-grow-1 {
  flex-grow: 1;
}

:host([grow="1"]) {
  min-height: 0;
}

:host([shrink="0"]),
.ids-layout-flex-item-shrink-0 {
  flex-shrink: 0;
}

:host([shrink="1"]),
.ids-layout-flex-item-shrink-1 {
  flex-shrink: 1;
}

:host([flex="1"]),
.ids-layout-flex-item-flex-1 {
  flex: 1;
}

:host([flex="2"]),
.ids-layout-flex-item-flex-2 {
  flex: 2;
}

:host([flex="3"]),
.ids-layout-flex-item-flex-3 {
  flex: 3;
}

:host([flex="4"]),
.ids-layout-flex-item-flex-4 {
  flex: 4;
}

:host([flex="5"]),
.ids-layout-flex-item-flex-5 {
  flex: 5;
}

:host([flex="6"]),
.ids-layout-flex-item-flex-6 {
  flex: 6;
}

:host([flex="7"]),
.ids-layout-flex-item-flex-7 {
  flex: 7;
}

:host([flex="8"]),
.ids-layout-flex-item-flex-8 {
  flex: 8;
}

:host([flex="9"]),
.ids-layout-flex-item-flex-9 {
  flex: 9;
}

:host([flex="10"]),
.ids-layout-flex-item-flex-10 {
  flex: 10;
}

:host([flex="11"]),
.ids-layout-flex-item-flex-11 {
  flex: 11;
}

:host([flex="12"]),
.ids-layout-flex-item-flex-12 {
  flex: 12;
}

:host([flex="13"]),
.ids-layout-flex-item-flex-13 {
  flex: 13;
}

:host([flex="14"]),
.ids-layout-flex-item-flex-14 {
  flex: 14;
}

:host([flex="15"]),
.ids-layout-flex-item-flex-15 {
  flex: 15;
}

:host([flex="16"]),
.ids-layout-flex-item-flex-16 {
  flex: 16;
}

:host([flex="17"]),
.ids-layout-flex-item-flex-17 {
  flex: 17;
}

:host([flex="18"]),
.ids-layout-flex-item-flex-18 {
  flex: 18;
}

:host([flex="19"]),
.ids-layout-flex-item-flex-19 {
  flex: 19;
}

:host([flex="20"]),
.ids-layout-flex-item-flex-20 {
  flex: 20;
}

:host([flex="21"]),
.ids-layout-flex-item-flex-21 {
  flex: 21;
}

:host([flex="22"]),
.ids-layout-flex-item-flex-22 {
  flex: 22;
}

:host([flex="23"]),
.ids-layout-flex-item-flex-23 {
  flex: 23;
}

:host([flex="24"]),
.ids-layout-flex-item-flex-24 {
  flex: 24;
}

:host([overflow=auto]),
.ids-layout-flex-item-overflow-auto {
  overflow: auto;
}

:host([overflow=hidden]),
.ids-layout-flex-item-overflow-hidden {
  overflow: hidden;
}

:host([overflow=visible]),
.ids-layout-flex-item-overflow-visible {
  overflow: visible;
}

:host([overflow=scroll]),
.ids-layout-flex-item-overflow-scroll {
  overflow: scroll;
}

:host(.has-container-grid[grow="0"][shrink="0"]),
.ids-layout-flex-item.has-container-grid.ids-layout-flex-item-grow-0.ids-layout-flex-item-shrink-0 {
  width: 100%;
}

::slotted(ids-input[size=full]) {
  display: inline-block;
}

:host([hide]) {
  display: none;
}

@container (width >= 320px) {
  :host([hide=xs]) {
    display: block;
  }
}
@container (width >= 767px) {
  :host([hide=sm]) {
    display: block;
  }
}
@container (width >= 927px) {
  :host([hide=md]) {
    display: block;
  }
}
@container (width >= 928px) {
  :host([hide=lg]) {
    display: block;
  }
}
@container (width >= 1183px) {
  :host([hide=xl]) {
    display: block;
  }
}
@container (width >= 2463px) {
  :host([hide=xxl]) {
    display: block;
  }
}
@media (width >= 320px) {
  :host([hide=xs]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 767px) {
  :host([hide=sm]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 927px) {
  :host([hide=md]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 928px) {
  :host([hide=lg]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 1183px) {
  :host([hide=xl]:not(.in-container)) {
    display: block;
  }
}
@media (width >= 2463px) {
  :host([hide=xxl]:not(.in-container)) {
    display: block;
  }
}
:host([hide=always]) {
  display: none;
}

:host(.ids-data-grid-sticky-layout-ancestor) {
  flex-grow: 1;
  min-block-size: 0;
  overflow: hidden;
}

:host,
.ids-layout-flex {
  display: flex;
}

:host([hidden]) {
  display: none;
}

:host([display=inline-flex]),
.ids-layout-flex-display-inline-flex {
  display: inline-flex;
}

:host([align-content=flex-start]),
.ids-layout-flex-align-content-flex-start {
  align-content: flex-start;
}

:host([align-content=flex-end]),
.ids-layout-flex-align-content-flex-end {
  align-content: flex-end;
}

:host([align-content=center]),
.ids-layout-flex-align-content-center {
  align-content: center;
}

:host([align-content=space-between]),
.ids-layout-flex-align-content-space-between {
  align-content: space-between;
}

:host([align-content=space-around]),
.ids-layout-flex-align-content-space-around {
  align-content: space-around;
}

:host([align-content=space-evenly]),
.ids-layout-flex-align-content-space-evenly {
  align-content: space-evenly;
}

:host([align-content=stretch]),
.ids-layout-flex-align-content-stretch {
  align-content: stretch;
}

:host([align-content=start]),
.ids-layout-flex-align-content-start {
  align-content: start;
}

:host([align-content=end]),
.ids-layout-flex-align-content-end {
  align-content: end;
}

:host([align-content=baseline]),
.ids-layout-flex-align-content-baseline {
  align-content: baseline;
}

:host([align-items=start]),
.ids-layout-flex-align-items-start {
  align-items: start;
}

:host([align-items=end]),
.ids-layout-flex-align-items-end {
  align-items: end;
}

:host([align-items=flex-start]),
.ids-layout-flex-align-items-flex-start {
  align-items: flex-start;
}

:host([align-items=flex-end]),
.ids-layout-flex-align-items-flex-end {
  align-items: flex-end;
}

:host([align-items=center]),
.ids-layout-flex-align-items-center {
  align-items: center;
}

:host([align-items=baseline]),
.ids-layout-flex-align-items-baseline {
  align-items: baseline;
}

:host([align-items=stretch]),
.ids-layout-flex-align-items-stretch {
  align-items: stretch;
}

:host([align-items=center-inputs]),
.ids-layout-flex-align-items-center-inputs {
  align-items: start;
}

:host([align-items=center-inputs]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-30);
}
:host([align-items=center-inputs]) ::slotted(ids-layout-flex-item.has-checkbox) {
  align-self: end;
}

:host([align-items=center-inputs][field-height=xs]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-10);
}

:host([align-items=center-inputs][field-height=sm]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-20);
}

:host([align-items=center-inputs][field-height=lg]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-40);
}

:host([direction=row]),
.ids-layout-flex-direction-row {
  flex-direction: row;
}

:host([direction=row-reverse]),
.ids-layout-flex-direction-row-reverse {
  flex-direction: row-reverse;
}

:host([direction=column]),
.ids-layout-flex-direction-column {
  flex-direction: column;
}

:host([direction=column-reverse]),
.ids-layout-flex-direction-column-reverse {
  flex-direction: column-reverse;
}

:host([justify-content=start]),
.ids-layout-flex-justify-content-start {
  justify-content: start;
}

:host([justify-content=stretch]),
.ids-layout-flex-justify-content-stretch {
  justify-content: stretch;
}

:host([justify-content=end]),
.ids-layout-flex-justify-content-end {
  justify-content: end;
}

:host([justify-content=flex-start]),
.ids-layout-flex-justify-content-flex-start {
  justify-content: flex-start;
}

:host([justify-content=flex-end]),
.ids-layout-flex-justify-content-flex-end {
  justify-content: flex-end;
}

:host([justify-content=center]),
.ids-layout-flex-justify-content-center {
  justify-content: center;
}

:host([justify-content=left]),
.ids-layout-flex-justify-content-left {
  justify-content: left;
}

:host([justify-content=right]),
.ids-layout-flex-justify-content-right {
  justify-content: right;
}

:host([justify-content=space-between]),
.ids-layout-flex-justify-content-space-between {
  justify-content: space-between;
}

:host([justify-content=space-around]),
.ids-layout-flex-justify-content-space-around {
  justify-content: space-around;
}

:host([justify-content=space-evenly]),
.ids-layout-flex-justify-content-space-evenly {
  justify-content: space-evenly;
}

:host([wrap=nowrap]),
.ids-layout-flex-wrap-nowrap {
  flex-wrap: nowrap;
}

:host([wrap=wrap]),
.ids-layout-flex-wrap-wrap {
  flex-wrap: wrap;
}

:host([wrap=wrap-reverse]),
.ids-layout-flex-wrap-wrap-reverse {
  flex-wrap: wrap-reverse;
}

:host([gap="0"]),
.ids-layout-flex-gap-0 {
  gap: 0px;
}

:host([gap="1"]),
.ids-layout-flex-gap-1 {
  gap: 1px;
}

:host([gap="2"]),
.ids-layout-flex-gap-2 {
  gap: 2px;
}

:host([gap="4"]),
.ids-layout-flex-gap-4 {
  gap: 4px;
}

:host([gap="8"]),
.ids-layout-flex-gap-8 {
  gap: 8px;
}

:host([gap="12"]),
.ids-layout-flex-gap-12 {
  gap: 12px;
}

:host([gap="16"]),
.ids-layout-flex-gap-16 {
  gap: 16px;
}

:host([gap="20"]),
.ids-layout-flex-gap-20 {
  gap: 20px;
}

:host([gap="24"]),
.ids-layout-flex-gap-24 {
  gap: 24px;
}

:host([gap="28"]),
.ids-layout-flex-gap-28 {
  gap: 28px;
}

:host([gap="32"]),
.ids-layout-flex-gap-32 {
  gap: 32px;
}

:host([gap="36"]),
.ids-layout-flex-gap-36 {
  gap: 36px;
}

:host([gap="40"]),
.ids-layout-flex-gap-40 {
  gap: 40px;
}

:host([gap-x="0"]),
.ids-layout-flex-gap-x-0 {
  row-gap: 0px;
}

:host([gap-x="1"]),
.ids-layout-flex-gap-x-1 {
  row-gap: 1px;
}

:host([gap-x="2"]),
.ids-layout-flex-gap-x-2 {
  row-gap: 2px;
}

:host([gap-x="4"]),
.ids-layout-flex-gap-x-4 {
  row-gap: 4px;
}

:host([gap-x="8"]),
.ids-layout-flex-gap-x-8 {
  row-gap: 8px;
}

:host([gap-x="12"]),
.ids-layout-flex-gap-x-12 {
  row-gap: 12px;
}

:host([gap-x="16"]),
.ids-layout-flex-gap-x-16 {
  row-gap: 16px;
}

:host([gap-x="20"]),
.ids-layout-flex-gap-x-20 {
  row-gap: 20px;
}

:host([gap-x="24"]),
.ids-layout-flex-gap-x-24 {
  row-gap: 24px;
}

:host([gap-x="28"]),
.ids-layout-flex-gap-x-28 {
  row-gap: 28px;
}

:host([gap-x="32"]),
.ids-layout-flex-gap-x-32 {
  row-gap: 32px;
}

:host([gap-x="36"]),
.ids-layout-flex-gap-x-36 {
  row-gap: 36px;
}

:host([gap-x="40"]),
.ids-layout-flex-gap-x-40 {
  row-gap: 40px;
}

:host([gap-y="0"]),
.ids-layout-flex-gap-y-0 {
  column-gap: 0px;
}

:host([gap-y="1"]),
.ids-layout-flex-gap-y-1 {
  column-gap: 1px;
}

:host([gap-y="2"]),
.ids-layout-flex-gap-y-2 {
  column-gap: 2px;
}

:host([gap-y="4"]),
.ids-layout-flex-gap-y-4 {
  column-gap: 4px;
}

:host([gap-y="8"]),
.ids-layout-flex-gap-y-8 {
  column-gap: 8px;
}

:host([gap-y="12"]),
.ids-layout-flex-gap-y-12 {
  column-gap: 12px;
}

:host([gap-y="16"]),
.ids-layout-flex-gap-y-16 {
  column-gap: 16px;
}

:host([gap-y="20"]),
.ids-layout-flex-gap-y-20 {
  column-gap: 20px;
}

:host([gap-y="24"]),
.ids-layout-flex-gap-y-24 {
  column-gap: 24px;
}

:host([gap-y="28"]),
.ids-layout-flex-gap-y-28 {
  column-gap: 28px;
}

:host([gap-y="32"]),
.ids-layout-flex-gap-y-32 {
  column-gap: 32px;
}

:host([gap-y="36"]),
.ids-layout-flex-gap-y-36 {
  column-gap: 36px;
}

:host([gap-y="40"]),
.ids-layout-flex-gap-y-40 {
  column-gap: 40px;
}

:host([gap=none]),
.ids-layout-flex-gap-none {
  gap: 0;
}

:host([gap-x=none]),
.ids-layout-flex-gap-x-none {
  row-gap: 0;
}

:host([gap-y=none]),
.ids-layout-flex-gap-y-none {
  column-gap: 0;
}

:host([gap=xs]),
.ids-layout-flex-gap-xs {
  gap: 8px;
}

:host([gap-x=xs]),
.ids-layout-flex-gap-x-xs {
  row-gap: 8px;
}

:host([gap-y=xs]),
.ids-layout-flex-gap-y-xs {
  column-gap: 8px;
}

:host([gap=sm]),
.ids-layout-flex-gap-sm {
  gap: 16px;
}

:host([gap-x=sm]),
.ids-layout-flex-gap-x-sm {
  row-gap: 16px;
}

:host([gap-y=sm]),
.ids-layout-flex-gap-y-sm {
  column-gap: 16px;
}

:host([gap=md]),
.ids-layout-flex-gap-md {
  gap: 24px;
}

:host([gap-x=md]),
.ids-layout-flex-gap-x-md {
  row-gap: 24px;
}

:host([gap-y=md]),
.ids-layout-flex-gap-y-md {
  column-gap: 24px;
}

:host([gap=lg]),
.ids-layout-flex-gap-lg {
  gap: 32px;
}

:host([gap-x=lg]),
.ids-layout-flex-gap-x-lg {
  row-gap: 32px;
}

:host([gap-y=lg]),
.ids-layout-flex-gap-y-lg {
  column-gap: 32px;
}

:host([gap=xl]),
.ids-layout-flex-gap-xl {
  gap: 40px;
}

:host([gap-x=xl]),
.ids-layout-flex-gap-x-xl {
  row-gap: 40px;
}

:host([gap-y=xl]),
.ids-layout-flex-gap-y-xl {
  column-gap: 40px;
}

:host([padding=xxs]),
.ids-layout-flex-padding-xxs {
  padding: 4px;
}

:host([padding-x=xxs]),
.ids-layout-flex-padding-x-xxs {
  padding-inline: 4px;
}

:host([padding-y=xxs]),
.ids-layout-flex-padding-y-xxs {
  padding-block: 4px;
}

:host([padding=xs]),
.ids-layout-flex-padding-xs {
  padding: 8px;
}

:host([padding-x=xs]),
.ids-layout-flex-padding-x-xs {
  padding-inline: 8px;
}

:host([padding-y=xs]),
.ids-layout-flex-padding-y-xs {
  padding-block: 8px;
}

:host([padding=sm]),
.ids-layout-flex-padding-sm {
  padding: 16px;
}

:host([padding-x=sm]),
.ids-layout-flex-padding-x-sm {
  padding-inline: 16px;
}

:host([padding-y=sm]),
.ids-layout-flex-padding-y-sm {
  padding-block: 16px;
}

:host([padding=md]),
.ids-layout-flex-padding-md {
  padding: 24px;
}

:host([padding-x=md]),
.ids-layout-flex-padding-x-md {
  padding-inline: 24px;
}

:host([padding-y=md]),
.ids-layout-flex-padding-y-md {
  padding-block: 24px;
}

:host([padding=lg]),
.ids-layout-flex-padding-lg {
  padding: 32px;
}

:host([padding-x=lg]),
.ids-layout-flex-padding-x-lg {
  padding-inline: 32px;
}

:host([padding-y=lg]),
.ids-layout-flex-padding-y-lg {
  padding-block: 32px;
}

:host([padding=xl]),
.ids-layout-flex-padding-xl {
  padding: 40px;
}

:host([padding-x=xl]),
.ids-layout-flex-padding-x-xl {
  padding-inline: 40px;
}

:host([padding-y=xl]),
.ids-layout-flex-padding-y-xl {
  padding-block: 40px;
}

:host([margin=xs]),
.ids-layout-flex-margin-xs {
  margin: 16px;
}

:host([margin-y=xs]),
.ids-layout-flex-margin-y-xs {
  margin-block: 16px;
}

:host([margin=sm]),
.ids-layout-flex-margin-sm {
  margin: 16px;
}

:host([margin-y=sm]),
.ids-layout-flex-margin-y-sm {
  margin-block: 16px;
}

:host([margin=md]),
.ids-layout-flex-margin-md {
  margin: 16px;
}

:host([margin-y=md]),
.ids-layout-flex-margin-y-md {
  margin-block: 16px;
}

:host([margin=lg]),
.ids-layout-flex-margin-lg {
  margin: 24px;
}

:host([margin-y=lg]),
.ids-layout-flex-margin-y-lg {
  margin-block: 24px;
}

:host([margin=xl]),
.ids-layout-flex-margin-xl {
  margin: 24px;
}

:host([margin-y=xl]),
.ids-layout-flex-margin-y-xl {
  margin-block: 24px;
}

:host([margin=auto]),
.ids-layout-flex-margin-auto {
  margin: auto;
}

:host([full-height]),
.ids-layout-flex-full-height {
  height: 100%;
}

::slotted(ids-icon),
.ids-layout-flex > .ids-icon {
  display: inline-flex;
}

:host(.ids-data-grid-sticky-layout-ancestor) {
  block-size: 100%;
  min-block-size: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
